module.exports = __webpack_public_path__ + "img/01.eb26ef87.jpg";